module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/color-spotify-fc3eee6a8c42ee2dfcbca6a73ae07741.svg";